export const commentDomId = (id) => `comment-${String(id || '')}`

export const commentFromSearch = (search) => {
  try {
    return new URLSearchParams(search || window.location.search).get('c') || ''
  } catch (err) {
    return ''
  }
}

export const scrollToComment = (commentId) => {
  const id = String(commentId || '').trim()
  if (!id) return false
  const el = document.getElementById(commentDomId(id))
  if (!el) return false
  el.classList.add('isTarget')
  el.scrollIntoView({ block: 'center', behavior: 'smooth' })
  window.setTimeout(() => el.classList.remove('isTarget'), 2500)
  return true
}
